const deliveryTime = {
  desc: 'Die Lieferzeit ist abhängig vom gewählten Material.',
  hint: '*zzgl. der Lieferzeit unserer Logistikpartner.'
}

export default {
  deliveryTime
}
